<div class="text-center">Redirecting please wait....</div>